import { helpers, mui, React, ts, ui } from '_core';

import { Tab, transform } from './helpers';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  file: string;
  fullScreen: boolean;
  title: string;
};

const Chart = ({ id, readOnly, loadWidgetData, file, fullScreen, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState(null);
  const [selectedTab, setSelectedTab] = React.useState<Tab>('forecast');

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file,
        },
      });
      if (response) setData(response.data);
    } catch (err) {
      setError(JSON.stringify(err));
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  const formattedData = React.useMemo(() => {
    return transform(data, selectedTab);
  }, [data, selectedTab]);

  const getTabs = () => {
    return (
      <mui.core.Tabs
        indicatorColor="primary"
        textColor="primary"
        value={selectedTab}
        onChange={(_e, newTab) => setSelectedTab(newTab)}
      >
        <mui.core.Tab label="Forecast" value="forecast" />
        <mui.core.Tab label="Realized" value="realized" />
        <mui.core.Tab label="Difference" value="diff" />
      </mui.core.Tabs>
    );
  };

  let yAxisLabel;
  if (selectedTab == 'forecast') {
    yAxisLabel = 'Annualized Forecast Asset Risk';
  } else if (selectedTab == 'realized') {
    yAxisLabel = 'Annualized Realized Asset Risk';
  } else {
    yAxisLabel = 'Realized - Forecast Annualized Asset Risk';
  }

  return (
    <mui.core.Box display="flex" flexDirection="column" style={{ height: '100%' }}>
      {getTabs()}
      <mui.core.Box p={3} flex="1">
        <ui.LineChart
          id={id}
          data={formattedData}
          fullScreen={fullScreen}
          readOnly={readOnly}
          alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
          exportTitle={title}
          yAxisLabel={yAxisLabel}
          numberFormat="#.##%"
        />
      </mui.core.Box>
    </mui.core.Box>
  );
};

export default Chart;
